<template>
  <div>
    <div class="top">
      <div class="top-center w-1200 d-flex j-end">
        <template v-if="$store.state.loginState">
          <div class="account"  v-if="$store.state.userInfo">{{$store.state.userInfo.personNo}}[{{$store.state.userInfo.personName}}]</div>
          <div class="change-pwd crr" @click="showChangePassword">修改密码</div>
          <div class="col-main f-bold crr" @click="logout">退出</div>
        </template>
        <div class="login col-main f-bold crr" @click="showLoginTip" v-else>登录</div>
        <div class="time">{{date}} {{week}}</div>
      </div>
    </div>
    <div class="title">
      <div class="title-center w-1200 d-flex a-center">
        <img src="../../assets/img/nav-logo.jpg"  class="logo" />
        <!-- <div class="tabs crr"
          v-for="(item, index) in student" :key="index"
          :class="{active: ishave($route.path, item.path)}"
          @click="toPath(item.path)"
          >
          {{item.name}}
        </div> -->
        <div class="tabs crr"
          :class="{active: ishave('/home')}"
          @click="toPath('/home')"
          >
          首页
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/notice/newsList')}"
          @click="toPath('/notice/newsList')"
          >
          干教资讯
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/specialTraining')}"
          @click="toPath('/specialTraining')"
          >
          专题培训
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/learning')}"
          @click="toPath('/learning')"
          v-if="$store.state.personType === 'student' || !this.$store.state.loginState"
          >
          学习课堂
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/course')}"
          @click="toPath('/course')"
          v-if="$store.state.personType === 'student' || !this.$store.state.loginState"
          >
          课程中心
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/teacher')}"
          @click="toPath('/teacher')"
          v-if="$store.state.personType === 'teacher'"
          >
          班级管理
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/tsg')}"
          @click="toPath('/tsg')"
          >
          数字图书
        </div>
        <!-- <div class="tabs crr"
          :class="{active: ishave('/exam')}"
          @click="toPath('/exam')"
          >
          在线考试
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/estimate')}"
          @click="toPath('/estimate')"
          >
          质量评估
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data () {
    return {
      student: [
        {
          name: '首页',
          path: '/home',
          show: true
        },
        {
          name: '干教资讯',
          path: '/notice/newsList',
          show: true
        },
        {
          name: '专题培训',
          path: '/specialTraining',
          show: true
        },
        {
          name: '学习课堂',
          path: '/learning/index',
          show: this.$store.state.personType === 'student' || !this.$store.state.loginState
        },
        {
          name: '课程中心',
          path: '/course/index',
          show: this.$store.state.personType === 'student' || !this.$store.state.loginState
        },
        {
          name: '班级管理',
          path: '/teacher/index',
          show: this.$store.state.personType === 'teacher'
        },
        {
          name: '数字图书',
          path: '/tsg',
          show: true
        },
        {
          name: '在线考试',
          path: '/exam',
          show: true
        },
        {
          name: '质量评估',
          path: '/estimate',
          show: true
        }
      ]
    }
  },
  computed: {
    date() {
      return moment().format("YYYY年MM月DD日")
    },
    week() {
      let num = moment().format("d")
      if(num === 0){
        return "星期天"
      }else if(num == 1){
        return "星期一"
      }else if(num == 2){
        return "星期二"
      }else if(num == 3){
        return "星期三"
      }else if(num == 4){
        return "星期四"
      }else if(num == 5){
        return "星期五"
      }else if(num == 6){
        return "星期六"
      }
    }
  },
  methods: {
    ishave(str2) {
      if(this.$route.path.indexOf(str2) === -1){
        return false
      }else{
        return true
      }
    },
    toPath(path) {
      if(this.$route.path == path){
        this.$router.go(0)
        return
      }
      if (['/train', '/learning', '/exam', '/estimate', '/specialTraining', '/tsg'].includes(path)) {
        if (!this.$store.state.loginState) {
          console.log(111)
          this.$store.commit('setLoginTip', true)
        } else {
          if (path === '/tsg') {
            const href = 'http://libjump.xaou.sn.cn:8082/'
            window.open(href, '_blank');
          } else {
            this.$router.push(path)
          }
        }
      } else if (path === '/information') {
        const href = 'https://www.sqgbpx.cn/news-list-xian2.html?book_id=44821175657824256&chapter_id=44821175663067136'
        window.open(href, '_blank');
      } else {
        this.$router.push(path)
      }
    },
    showChangePassword() {
      if(this.$store.state.loginPhone){
        this.$store.commit('setChangePassword',true)
      }else{
        this.$store.commit('setLoginTip',true)
      }
    },
    showLoginTip() {
      this.$store.commit('setLoginTip', true)
    },
    logout() {
      this.$api.login.exitLogin().then(res => {
        this.$store.commit('exitLogin')
        if (this.$route.path !== '/home') {
          this.$router.replace('/home')
        }
        setTimeout(()=>{
          this.$message.success('已退出登录！')
        }, 30)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.top{
  background: #eee;
  .top-center{
    padding: 5px 0;
    .account{
      position: relative;
      padding-right: 10px;
      margin-right: 15px;
    }
    .account::after{
      position: absolute;
      top: 4px;
      right: -2px;
      content: "";
      height: 16px;
      width: 2px;
      background-color: rgb(192, 192, 192);
    }
    .change-pwd{
      margin-right: 20px;
    }
    .time{
      margin-left: 30px;
      font-weight: bold;
    }
  }
}
.title{
  background: #fff;
  padding: 10px 0;
  .title-center{
    .logo{
      width: 295px;
    }
    .tabs{
      margin: 0 20px;
      padding-bottom: 4px;
      border-bottom: 2px solid #fff;
      &:hover{
        border-bottom: 2px solid #E10019;
      }
    }
    .active{
      border-bottom: 2px solid #E10019;
    }
  }
}
</style>
